import { SearchProvider, WithSearch } from "@elastic/react-search-ui";
import { ElasticWrapper } from "components/common";
import { useStoreContext } from "context/StoreProvider";
import { useEffect, useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { getCodeSystem, resultsPerPage } from "utils";

import { SearchPageLayout } from "../common";
import { NLKFilter, NLKTable } from "./common";
import { nlkConfig } from "./config/nlkConfig";

const NLKSearch = () => {
  const { t } = useTranslation();

  const { state, actions } = useStoreContext();
  const { code } = state;
  const { updateCodeSystem } = actions;

  const { pathname } = useLocation();

  useEffect(() => {
    document.title = `${t("general.finnkode")} - ${t(
      "codesystems.labCodework.nlk"
    )}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    updateCodeSystem(getCodeSystem(pathname) as string);
  }, [pathname, updateCodeSystem]);

  return (
    <SearchProvider
      config={{
        initialState: {
          searchTerm: code ?? "",
          resultsPerPage: resultsPerPage
        },
        ...nlkConfig
      }}
    >
      <WithSearch
        mapContextToProps={({ searchTerm, results, isLoading }) => ({
          searchTerm,
          results,
          isLoading
        })}
      >
        {({ results, searchTerm, isLoading }) => {
          return (
            <ElasticWrapper className="d-flex flex-column">
              <SearchPageLayout
                headingLabel={t("nlkPage.title")}
                results={results}
                searchTerm={searchTerm}
                isLoading={isLoading}
                hideSidebar={false}
                bodyResults={<NLKTable />}
                sidebarContent={<NLKFilter />}
              />
            </ElasticWrapper>
          );
        }}
      </WithSearch>
    </SearchProvider>
  );
};

export default NLKSearch;
